import { createContext } from "react";

export interface ISharedContentProps {
    shareToken: string | undefined;
}

// Can add SharedContentEntity later as/if needed
export const SharedContentContext = createContext<ISharedContentProps>({
    shareToken: undefined,
});

export const SharedContentProvider: React.FC<ISharedContentProps> = ({ shareToken, children }) => {
    return (
        <SharedContentContext.Provider value={{ shareToken }}>
            {children}
        </SharedContentContext.Provider>
    );
};
